import { MutationTree } from "vuex";
import { AuthState } from "@/components/auth/types";

export const mutations: MutationTree<AuthState> = {};
